<template>
  <div class="c-calendar__tooltip-day-marker">
    <span v-for="n in numberOfDays" :key="n" class="c-calendar__tooltip-day-marker-bar"></span>
  </div>
</template>
<script>
export default {
  name: "WeekDayContentDayGraphic",
  props: {
    numberOfDays: {
      type: Number,
      default: 1
    }
  }
};
</script>